import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { displayFieldGroups } from "../utils/config-pages.js";

var root = $.from_html(`<label class="display-flag svelte-3gufk7"><input type="checkbox" class="svelte-3gufk7"/> <span> </span></label>`);
var root_1 = $.from_html(`<div class="display-flags svelte-3gufk7"></div>`);
var root_2 = $.from_html(`<option> </option>`);
var root_3 = $.from_html(`<select class="svelte-3gufk7"><option>(not set)</option><!></select>`);
var root_4 = $.from_html(`<input class="svelte-3gufk7"/>`);
var root_5 = $.from_html(`<label class="display-field svelte-3gufk7"><span class="display-field-label svelte-3gufk7"> </span> <!></label>`);
var root_6 = $.from_html(`<div class="display-grid svelte-3gufk7"></div>`);
var root_7 = $.from_html(`<section class="display-group svelte-3gufk7"><h4 class="svelte-3gufk7"> </h4> <!> <!></section>`);
var root_8 = $.from_html(`<div class="display-fields svelte-3gufk7"></div>`);

const $$css = {
	hash: 'svelte-3gufk7',
	code: '.display-fields.svelte-3gufk7 {display:flex;flex-direction:column;gap:0.9rem;}.display-group.svelte-3gufk7 h4:where(.svelte-3gufk7) {margin:0 0 0.35rem;font-size:0.6875rem;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;color:#6b7280;}\n\n  /* Switches wrap onto as many lines as they need, each one a thumb wide. */.display-flags.svelte-3gufk7 {display:flex;flex-wrap:wrap;gap:0 1rem;margin-bottom:0.35rem;}.display-flag.svelte-3gufk7 {display:flex;align-items:center;gap:0.5rem;min-height:2.5rem;font-size:0.8125rem;color:#111827;}.display-flag.svelte-3gufk7 input:where(.svelte-3gufk7) {flex:0 0 auto;width:1.25rem;height:1.25rem;accent-color:#087bc4;}\n\n  /* Two columns wherever they fit, one on a narrow phone. The boxes line up at\n     their bottom edge, whatever the label above them wraps to. */.display-grid.svelte-3gufk7 {display:grid;grid-template-columns:repeat(auto-fit, minmax(7.5rem, 1fr));align-items:end;gap:0.45rem 0.75rem;}.display-field.svelte-3gufk7 {display:flex;flex-direction:column;gap:0.15rem;min-width:0;font-size:0.8125rem;}.display-field-label.svelte-3gufk7 {color:#4b5563;line-height:1.25;}.display-field.svelte-3gufk7 input[type="text"]:where(.svelte-3gufk7),\n  .display-field.svelte-3gufk7 input[type="number"]:where(.svelte-3gufk7),\n  .display-field.svelte-3gufk7 select:where(.svelte-3gufk7) {width:100%;min-width:0;min-height:2.5rem;box-sizing:border-box;padding:0.3rem 0.5rem;border:1px solid #d1d5db;border-radius:0.375rem;background:#ffffff;color:#111827;font:inherit;font-size:0.9375rem;}[data-theme="dark"] .display-group.svelte-3gufk7 h4:where(.svelte-3gufk7) {color:#9ca3af;}[data-theme="dark"] .display-field-label.svelte-3gufk7 {color:#9ca3af;}[data-theme="dark"] .display-flag.svelte-3gufk7 {color:#e5e7eb;}[data-theme="dark"] .display-field.svelte-3gufk7 input[type="text"]:where(.svelte-3gufk7),\n  [data-theme="dark"] .display-field.svelte-3gufk7 input[type="number"]:where(.svelte-3gufk7),\n  [data-theme="dark"] .display-field.svelte-3gufk7 select:where(.svelte-3gufk7) {background:#111827;border-color:#4b5563;color:#e5e7eb;}'
};

export default function DisplayFields($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	/** The fields of one display table. The owner keeps the draft. */
	let draft = $.prop($$props, 'draft', 7);

	/** A switch and a field are read differently, so they are laid out apart. */
	const groups = displayFieldGroups().map((group) => ({
		name: group.name,
		flags: group.fields.filter((field) => field.kind === "boolean"),
		values: group.fields.filter((field) => field.kind !== "boolean")
	}));

	var div = root_8();

	$.each(div, 21, () => groups, (group) => group.name, ($$anchor, group) => {
		var section = root_7();
		var h4 = $.child(section);
		var text = $.only_child(h4, true);
		var node = $.sibling(h4, 2);

		{
			var consequent = ($$anchor) => {
				var div_1 = root_1();

				$.each(div_1, 21, () => $.get(group).flags, (field) => field.key, ($$anchor, field) => {
					var label = root();
					var input = $.child(label);

					$.remove_input_defaults(input);

					var span = $.sibling(input, 2);
					var text_1 = $.only_child(span, true);

					$.reset(label);

					$.template_effect(() => {
						$.set_attribute(label, 'title', $.get(field).hint ?? "");
						$.set_checked(input, draft()[$.get(field).key] === "true");
						$.set_attribute(input, 'aria-label', $.get(field).label);
						$.set_text(text_1, $.get(field).label);
					});

					$.delegated('change', input, (event) => draft()[$.get(field).key] = event.currentTarget.checked ? "true" : "false");
					$.append($$anchor, label);
				});

				$.reset(div_1);
				$.append($$anchor, div_1);
			};

			$.if(node, ($$render) => {
				if ($.get(group).flags.length > 0) $$render(consequent);
			});
		}

		var node_1 = $.sibling(node, 2);

		{
			var consequent_2 = ($$anchor) => {
				var div_2 = root_6();

				$.each(div_2, 21, () => $.get(group).values, (field) => field.key, ($$anchor, field) => {
					var label_1 = root_5();
					var span_1 = $.child(label_1);
					var text_2 = $.only_child(span_1, true);
					var node_2 = $.sibling(span_1, 2);

					{
						var consequent_1 = ($$anchor) => {
							var select = root_3();
							var option_1 = $.child(select);

							option_1.value = option_1.__value = '';

							var node_3 = $.sibling(option_1);

							$.each(node_3, 16, () => $.get(field).options ?? [], (option) => option, ($$anchor, option) => {
								var option_2 = root_2();
								var text_3 = $.only_child(option_2, true);
								var option_2_value = {};

								$.template_effect(() => {
									$.set_text(text_3, option);

									if (option_2_value !== (option_2_value = option)) {
										option_2.value = (option_2.__value = option_2_value) ?? '';
									}
								});

								$.append($$anchor, option_2);
							});

							$.reset(select);
							$.init_select(select);
							$.template_effect(() => $.set_attribute(select, 'aria-label', $.get(field).label));
							$.bind_select_value(select, () => draft()[$.get(field).key], ($$value) => draft()[$.get(field).key] = $$value);
							$.append($$anchor, select);
						};

						var alternate = ($$anchor) => {
							var input_1 = root_4();

							$.remove_input_defaults(input_1);

							$.template_effect(() => {
								$.set_attribute(input_1, 'type', $.get(field).kind === "number" ? "number" : "text");
								$.set_attribute(input_1, 'placeholder', $.get(field).fallback ?? "");
								$.set_attribute(input_1, 'aria-label', $.get(field).label);
							});

							$.bind_value(input_1, () => draft()[$.get(field).key], ($$value) => draft()[$.get(field).key] = $$value);
							$.append($$anchor, input_1);
						};

						$.if(node_2, ($$render) => {
							if ($.get(field).kind === "select") $$render(consequent_1); else $$render(alternate, -1);
						});
					}

					$.reset(label_1);

					$.template_effect(() => {
						$.set_attribute(label_1, 'title', $.get(field).hint ?? "");
						$.set_text(text_2, $.get(field).label);
					});

					$.append($$anchor, label_1);
				});

				$.reset(div_2);
				$.append($$anchor, div_2);
			};

			$.if(node_1, ($$render) => {
				if ($.get(group).values.length > 0) $$render(consequent_2);
			});
		}

		$.reset(section);
		$.template_effect(() => $.set_text(text, $.get(group).name));
		$.append($$anchor, section);
	});

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['change']);